import desktop_background_main from 'art/desktop_background_main.png';
import desktop_background_gravestone from 'art/desktop_background_gravestone.png';
import clouds from 'art/clouds.png';
import BackgroundDark from 'components/BackgroundImage/BackgroundDark';
import BackgroundTransitions from 'components/BackgroundImage/BackgroundTransitions';
import { gameStateType } from 'core/constants';
import { dayBlue, nightBlue } from 'core/styles';
import React from 'react';
import { useSelector } from 'react-redux';
import { getLocation } from 'reducer/location';
import styled, { keyframes } from 'styled-components';
import desktop_background_zoomed from 'art/desktop_background_zoomed.png';
import darker_lobby from 'art/darker_lobby.png';

export const BackgroundHome = styled.img.attrs(() => ({
  src: desktop_background_zoomed,
  alt: 'Picture of player characters',
}))`
  top: 0;
  height: auto;
  width: 100%;
  z-index: -2;
  position: fixed;
  height: auto;
  opacity: ${({ active }) => (active ? 1 : 0)};
  pointer-events: none;
  transition: opacity 0.5s ease-in-out;
`;

export const BackgroundLobby = styled.img.attrs(() => ({
  src: darker_lobby,
  alt: 'Graveyard Lobby',
}))`
  top: 0;
  height: auto;
  width: 100%;
  z-index: -1;
  position: fixed;
  height: auto;
  opacity: ${({ active }) => (active ? 1 : 0)};
  pointer-events: none;
`;

const {
  // WAITING,
  // READY,
  INTRO,
  STARTED,
  NIGHT_INTRO,
  NIGHT,
  MORNING_INTRO,
  MORNING,
  DAY,
  POLLS,
  VAMPIRE_WIN,
  HUMAN_WIN,
} = gameStateType;

const Graveyard = styled.img.attrs(() => ({
  src: desktop_background_main,
  alt: 'Graveyard at night with vampire on tombstone',
}))`
  top: 0;
  height: auto;
  width: 100%;
  min-width: 50%;
  z-index: -1;
  position: fixed;
  opacity: ${({ active }) => (active ? 1 : 0)};
`;

const GraveyardTombstone = styled.img.attrs(() => ({
  src: desktop_background_gravestone,
  alt: 'Graveyard at night with vampire on tombstone',
}))`
  top: 0;
  height: auto;
  width: 100%;
  min-width: 50%;
  z-index: -1;
  position: fixed;
  opacity: ${({ active }) => (active ? 1 : 0)};
`;

const moveClouds = keyframes`
    from {
      left: -90%;
    }
    to {
      left: 55%;
    }
`;

const Clouds = styled.img.attrs(() => ({
  src: clouds,
  alt: 'Clouds moving by',
}))`
  top: 0;
  height: auto;
  width: 100%;
  min-width: 50%;
  z-index: -2;
  position: fixed;
  animation: ${moveClouds} 60s linear infinite;
`;

const BackgroundColor = styled.div`
  top: 0;
  height: 100%;
  width: 100%;
  position: fixed;
  background-image: ${({ color }) => color};
  z-index: ${({ active }) => (active ? -3 : -4)};
  opacity: ${({ active }) => (active ? 1 : 0)};
  pointer-events: none;
`;

const BackgroundImage = () => {
  const locationState = useSelector(getLocation);
  const pathname = locationState?.pathname;
  
  // Show home background for root, /desktop, or when pathname is not set
  const isHome = !pathname || pathname === '/' || pathname === '' || pathname === '/desktop';

  const showDay = pathname && [
    `/PlayGame/${MORNING}`,
    `/PlayGame/${DAY}`,
    `/PlayGame/${POLLS}`,
    `/desktop/PlayGame/${MORNING}`,
    `/desktop/PlayGame/${DAY}`,
    `/desktop/PlayGame/${POLLS}`,
  ].includes(pathname);
  const showNight = pathname && [
    '/PlayGame/WaitingRoom',
    `/PlayGame/${INTRO}`,
    `/PlayGame/${NIGHT}`,
    '/desktop/PlayGame/WaitingRoom',
    `/desktop/PlayGame/${INTRO}`,
    `/desktop/PlayGame/${NIGHT}`,
  ].includes(pathname);

  return (
    <>
      <BackgroundTransitions />
      <BackgroundHome active={isHome} />
      <BackgroundLobby active={pathname && (['/PlayGame/WaitingRoom', '/desktop/PlayGame/WaitingRoom'].includes(pathname))} />
      <BackgroundDark
        active={pathname && [
          '/Settings/',
          '/Rules/',
          '/Credit/',
          '/desktop/Settings',
          '/desktop/Rules',
          '/desktop/Credit',
          `/PlayGame/${STARTED}`,
          `/PlayGame/${VAMPIRE_WIN}`,
          `/PlayGame/${HUMAN_WIN}`,
          `/desktop/PlayGame/${STARTED}`,
          `/desktop/PlayGame/${VAMPIRE_WIN}`,
          `/desktop/PlayGame/${HUMAN_WIN}`,
        ].includes(pathname)}
      />
      <Graveyard
        active={pathname && [
          `/PlayGame/${INTRO}`,
          `/PlayGame/${NIGHT}`,
          `/PlayGame/${DAY}`,
          `/desktop/PlayGame/${INTRO}`,
          `/desktop/PlayGame/${NIGHT}`,
          `/desktop/PlayGame/${DAY}`,
        ].includes(pathname)}
      />
      <GraveyardTombstone
        active={pathname && [
          `/PlayGame/${INTRO}`,
          `/PlayGame/${MORNING}`,
          `/PlayGame/${POLLS}`,
          `/desktop/PlayGame/${INTRO}`,
          `/desktop/PlayGame/${MORNING}`,
          `/desktop/PlayGame/${POLLS}`,
        ].includes(pathname)}
      />
          `/PlayGame/${POLLS}`,
        ].includes(pathname)}
      />
      {showDay && <Clouds />}
      <BackgroundColor color={nightBlue} active={showNight} />
      <BackgroundColor color={dayBlue} active={showDay} />
    </>
  );
};
export default BackgroundImage;
